const DateFilterButtonData = ['오늘', '1주일', '1개월', '3개월', '6개월', '1년', '전체'];

export default DateFilterButtonData;
